import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { IconButton } from "@ui-kit/Button";
import type { ReactNode } from "react";

type Props = {
	onRemove?: () => void;
	onDownload?: () => void;
	isDownloading?: boolean;
	children: ReactNode;
};

const cornerButtonClassName =
	"absolute right-0.5 top-0.5 size-5 p-0.5 opacity-0 bg-background group-hover:opacity-100 focus-visible:opacity-100";

export const AttachmentTile = ({ onRemove, onDownload, isDownloading, children }: Props) => (
	<div className="group relative size-20 shrink-0 overflow-hidden rounded-lg border-[0.5px] border-secondary-border bg-secondary-bg">
		{children}
		{onRemove && (
			<IconButton
				aria-label={t("agent.tooltips.remove-attachment")}
				className={cornerButtonClassName}
				icon="x"
				iconClassName="size-2.5"
				onClick={onRemove}
				size="xs"
				variant="ghost"
			/>
		)}
		{onDownload && (
			<IconButton
				aria-label={t("agent.tooltips.download-attachment")}
				className={cn(cornerButtonClassName, isDownloading && "opacity-100")}
				disabled={isDownloading}
				icon={isDownloading ? "loader-circle" : "download"}
				iconClassName={cn("size-2.5", isDownloading && "animate-spin")}
				onClick={onDownload}
				size="xs"
				variant="ghost"
			/>
		)}
	</div>
);
